import { render } from "./ImportAdd.vue?vue&type=template&id=0197e653"
import script from "./ImportAdd.vue?vue&type=script&lang=js"
export * from "./ImportAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__